<ng-container *transloco="let t">
  <div class="popsy-phone-price-filter">
    <section class="slider">
      <app-range-input
        [minAmount]="selectedMinPrice"
        [maxAmount]="selectedMaxPrice"
        [currency]="selectedCurrency"
        [direction]="(isRtlLayout$ | async) ? 'rtl' : 'ltr'"
        (priceChanged)="priceUpdated($event)"
        (livePrice)="priceUpdated($event)"
        [ariaLabel]="t('filter_title_price')"
        [showAmountLabel]="false">
      </app-range-input>
    </section>

    <span aria-hidden="true" class="fixed-space-8"></span>

    <section class="inputs">
      <form
        class="form"
        name="price-filter-form"
        (ngSubmit)="applyPriceFilter()"
        [formGroup]="priceFilterForm">
        <section class="popsy-text-field" *ngIf="loading !== true">
          <span aria-hidden="true" class="fixed-space-4"></span>
          <input
            data-clarity-unmask
            #minPrice
            type="number"
            class="field"
            [class.big]="mobile"
            id="filter_title_min_price"
            [formControl]="minPriceFormControl"
            inputmode="decimal"
            name="min-price"
            autocomplete="min-price"
            (keydown.enter)="applyPriceFilter('min-price')" />
          <!-- <span class="error-label" *ngIf="error && initialized">{{ error }}</span> -->

          <span aria-hidden="true" class="fixed-space-4"></span>
        </section>

        <span aria-hidden="true" class="fixed-space-8"></span>
        <span class="separation">{{ '-' }}</span>
        <span aria-hidden="true" class="fixed-space-8"></span>

        <section class="popsy-text-field" *ngIf="loading !== true">
          <input
            data-clarity-unmask
            #maxPrice
            type="number"
            class="field"
            [class.big]="mobile"
            id="filter_title_max_price"
            [formControl]="maxPriceFormControl"
            inputmode="decimal"
            name="max-price"
            autocomplete="max-price"
            (keydown.enter)="applyPriceFilter('max-price')" />
          <!-- <span class="error-label" *ngIf="error && initialized">{{ error }}</span> -->
        </section>
      </form>
    </section>
    <span aria-hidden="true" class="fixed-space-24"></span>
  </div>
</ng-container>
